import type { IStore } from "~/state/store";
import type { TWasmMapClick } from "../wasm";
import type { IConfig } from "~/config";
import type WasmStoreMapping from "../mapping";
import { openPanoramaAt } from "~/util/providers/pano";
import { openDIM } from "~/util/userweb";
import { getPOI } from "~/route/utils";
import Scene from "~/scene";

export function onMapClick(data: TWasmMapClick, store: IStore, CONFIG: IConfig, mapping: WasmStoreMapping) {
	// vlastni body - kliklo se do mapy, ale ne na nejaky nas element v mape
	if (Mapy.getComponent("userMarks").isActive()) {
		!data.wasmId && Mapy.getComponent("userMarks").addItem([data.longitude, data.latitude]);
	// rucni mereni - kliklo se do mapy, ale ne na nejaky nas element v mape
	} else if (Mapy.getComponent("distanceMeter").isActive()) {
		Mapy.getComponent("distanceMeter").add([data.longitude, data.latitude]);
	// routovac
	} else if (Mapy.getComponent("route").isActive() && !Mapy.CML.state.route.readOnly && !data.wasmId) {
		// TODO: predelat na chovani dle provozu
		const curState = Mapy.CML.state.route;

		if (curState.readOnly) {
			return;
		}

		Mapy.CML.state = {
			route: {
				loading: true,
			},
		};

		const coords = Scene.coordsFromWGS84(data.longitude, data.latitude);

		getPOI(coords).then(dataPoi => {
			const items = Mapy.CML.state.route.items;

			items.push(dataPoi);
			Mapy.CML.state = {
				route: {
					items,
					scroll: true,
					zoom: false,
					loading: false,
				},
			};
			Mapy.getComponent("history").save();
		}, () => {});
	// kliklo se na nejaky marker v mape, ktery zjistime az kdyz si precteme jeho data
	} else if (data.wasmId) {
		const storeId = mapping.getWasmToStoreId(data.wasmId);
		const { markers, geometries } = store.getState().mapContent;
		const wasmMarker = markers.find(marker => marker.id === storeId);
		const wasmGeometry = geometries.find(geometry => geometry.id === storeId);

		if (wasmMarker) {
			// neco, co reprezentuje POI
			if (wasmMarker.customData?.poi) {
				if (wasmMarker.type === "photo") {
					Mapy.getComponent("photoDetail").setData({
						source: wasmMarker.customData.poi.source,
						id: wasmMarker.customData.poi.id,
					}).activate();
					Mapy.getComponent("history").save();
				} else {
					Mapy.getComponent("detail").setState({
						source: wasmMarker.customData.poi.source,
						id: wasmMarker.customData.poi.id,
						show: false,
					}).then(() => {
						Mapy.getComponent("history").save();
					}, () => {});
				}
			// trvale nad mapou a veci z MM
			} else if (wasmMarker?.customData?.dim) {
				openDIM(wasmMarker.customData.dim, { inFrame: CONFIG.inFrame });
			} else if (wasmMarker.customData?.component === "activities") {
				Mapy.getComponent("activities").open(wasmMarker.customData.customId);
			}
		}

		if (wasmGeometry) {
			// prepinani alternativy v routovaci
			if (Mapy.getComponent("route").isActive() && wasmGeometry.customData?.route?.routeIndex !== undefined && wasmGeometry.customData?.route?.routeIndex !== Mapy.CML.state.route.index) {
				Mapy.CML.state = {
					route: {
						index: wasmGeometry.customData?.route?.routeIndex,
						zoom: false,
					},
				};
			}
		}
	// kliklo se na panorama cary v mape
	} else if (data.rasterLayer === "panoLayer") {
		openPanoramaAt({
			lon: data.longitude,
			lat: data.latitude,
			zoom: store.getState().map.zoom,
			selYear: Mapy.getComponent("pano").getYear(),
		}).then(() => {
			Mapy.getComponent("history").save();
		}, () => {});
	// nic interaktivniho neni aktivni, ale kliklo se na POI
	} else if (data.pois?.length) {
		Mapy.getComponent("detail").setState({
			source: data.pois[0].source,
			id: data.pois[0].id,
			show: false,
		}).then(() => {
			Mapy.getComponent("history").save();
		}, () => {});
	}
}
